import type { Collection, Item } from '../api/CollectionsAPI';

/** Next `placeOrder` when appending an item to the end of a catalog list. */
export function nextAppendPlaceOrder(items: Item[]): number {
  if (!items.length) {
    return 0;
  }
  return Math.max(...items.map((i) => i.placeOrder ?? 0)) + 1;
}

/** PATCH body for moving an item to another collection (path carries target collection id). */
export function buildItemPayloadForMoveToCollection(item: Item, targetCollection: Collection): Item {
  const { files: _files, ...rest } = item;
  const placeOrder = nextAppendPlaceOrder(targetCollection.items ?? []);
  return {
    ...rest,
    placeOrder,
    collection: targetCollection.id,
    collectionName: targetCollection.name,
  };
}
